/* eslint-disable no-undef */

import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles/index'
import parse from 'html-react-parser'

const styles = theme => ({
    root: {
        marginBottom: theme.layoutAlias === 'exclusive' ? theme.spacing(4) : null
    },
    defaultContainer: {
        paddingTop: theme.layoutAlias === 'exclusive' ? 0 : 30,
        marginBottom: 5,
        textAlign: 'center',
        fontSize: 11,
        textTransform: 'uppercase',
        letterSpacing: 0.5,
        color: theme.termsColor ? theme.termsColor + '!important' : 'rgba(0,0,0,0.41)!important',
        marginTop: 'auto',
        width: '100%'
    },
    disclaimerContainer: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(1),
        '& h3, & h4, & p': {
            margin: 0
        }
    },
    smallDisclaimerContainer: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(1),
        fontSize: '0.8rem',
        color: theme.termsColor ? theme.termsColor + '!important' : 'rgba(0,0,0,0.41)!important',
        '& h3, & h4, & p': {
            margin: 0
        }
    },
    link: {
        color: theme.termsColor ? theme.termsColor + '!important' : 'rgba(0,0,0,0.41)!important',
        textDecoration: 'none'
    }
})

function getTermsLabel() {
    if (process.env.MIX_APP_COUNTRY === 'denmark') {
        return 'Vilkår'
    }
    if (process.env.MIX_APP_COUNTRY === 'sweden') {
        return 'Villkor'
    }
    return 'Palvelun käyttöehdot'
}

function getPrivacyPolicyLabel() {
    if (process.env.MIX_APP_COUNTRY === 'denmark') {
        return 'Fortrolighedspolitik'
    }
    if (process.env.MIX_APP_COUNTRY === 'sweden') {
        return 'Integritetspolicy'
    }
    return 'Tietosuoja'
}

function getRulesLabel() {
    if (process.env.MIX_APP_COUNTRY === 'denmark') {
        return 'Regler'
    }
    if (process.env.MIX_APP_COUNTRY === 'sweden') {
        return 'Regler'
    }
    return 'Säännöt'
}

class Terms extends Component {
    state = {}

    render() {
        const { classes, domain, paddingTop } = this.props
        return (
            <div className={classes.root}>
                {process.env.MIX_APP_COUNTRY === 'denmark' ? (
                    <div className={classes.disclaimerContainer}>{domain.disclaimer && parse(domain.disclaimer)}</div>
                ) : (
                    <>
                        <div className={classes.defaultContainer} style={{ paddingTop: paddingTop ?? null }}>
                            <a href={domain.main} className={classes.link} target="blank">
                                {domain.label}
                            </a>{' '}
                            |{' '}
                            <a href={domain.terms} className={classes.link} target="blank">
                                {getTermsLabel()}
                            </a>{' '}
                            |{' '}
                            <a href={domain.privacy_policy} className={classes.link} target="blank">
                                {getPrivacyPolicyLabel()}
                            </a>
                            {domain.direct_marketing_policy && (
                                <>
                                    {' | '}
                                    <a href={domain.direct_marketing_policy} className={classes.link} target="blank">
                                        {getRulesLabel()}
                                    </a>
                                </>
                            )}
                        </div>
                        {domain.disclaimer && <div className={classes.smallDisclaimerContainer}>{parse(domain.disclaimer)}</div>}
                    </>
                )}
            </div>
        )
    }
}

export default withStyles(styles)(Terms)
